// extracted by mini-css-extract-plugin
export default {"container":"businessDistribution_container__0ksln","row":"businessDistribution_row__0Y8yB","chart":"businessDistribution_chart__KyZch","table":"businessDistribution_table__aDH-N"};